import { html, css } from 'lit';
import { Styles } from '../types/types';
import OlComponent from './OlComponent';

export default class WordSpacingComponent extends OlComponent {
    onClick: (value: Styles["word-spacing"]) => void;

    constructor(onClick: (value: Styles["word-spacing"]) => void) {
        super();
        this.onClick = onClick;
    }

    override styles = css`
    .lh-buttons button {
        border-radius: 20px;
        border: none;
        white-space: nowrap;
        text-align: center;
    }
    .lh-buttons button:hover {
        box-shadow: 2px 2px 3px 2px rgba(0,0,0,.1);
        opacity: 1;
    }
`

    override render() {
        return (
            html`
            <style>${this.styles}</style>
            <div class="lh-buttons container">
                <button @click=${() => this.onClick("normal")} part="button" style="word-spacing: normal">normal spacing</button>
                <button @click=${() => this.onClick("10px")} part="button" style="word-spacing: 10px">big spacing</button>
                <button @click=${() => this.onClick("-2px")} part="button" style="word-spacing: -2px">small spacing</button>
            </div>`
        )
    }
}